const MONTHLY_EXPENSE_UPDATE = 'bfb/monthly_expense/MONTHLY_EXPENSE_UPDATE';

export default {
  MONTHLY_EXPENSE_UPDATE,
};
